/* eslint-disable @typescript-eslint/no-unused-vars */
import { useLazyQuery, useMutation } from '@apollo/client'
import { Button, CircularProgress, Typography } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { toast } from 'react-toastify'

import PageHeader from '../../components/PageHeader'
import PermissionBox from '../../components/PermissionBox'
import {
  UPDATE_USER_PERMISSIONS_MUTATION,
  USER_PERMISSIONS_QUERY
} from '../../graphql/permissions'
import { getTranslate } from '../../localization'
import { Permission } from '../../types/role'
import Filters from './filters'
import useStyles from './styles/index.styles'

function UserPermissions() {
  const classes = useStyles()
  const history = useHistory()
  const params = useParams<{ id: string }>()
  const [initialPermissions, setInitialPermissions] = useState<Permission[]>([])
  const [temporaryPermissions, setTemporaryPermissions] = useState<
    Permission[]
  >([])
  const [filteredPermissions, setfilteredPermissions] = useState<Permission[]>(
    []
  )

  const [getUserPermission, { loading: loadingForPermissions }] = useLazyQuery<{
    userPermissions: Permission[]
  }>(USER_PERMISSIONS_QUERY, {
    notifyOnNetworkStatusChange: true,
    fetchPolicy: 'network-only',
    onCompleted: (res) => {
      setInitialPermissions(res.userPermissions)
      setTemporaryPermissions(res.userPermissions)
    }
  })

  const [updateUserPErmissions, { loading: loadingForUpdatePermissions }] =
    useMutation(UPDATE_USER_PERMISSIONS_MUTATION, {
      onCompleted: (res) => {
        toast.success(res.userPermissions.message)
      },
      onError: (err) => {
        toast.error(err.message)
      }
    })

  useEffect(() => {
    getUserPermission({ variables: { userID: params.id } })
  }, [])

  return (
    <div className={classes.main}>
      <div className={classes.root}>
        <PageHeader title={getTranslate('User Permissions')} />
        {/* <AppBar position="static" color="transparent">
          <Breadcrumbs levels={cachedLevels} loading={loading} />
        </AppBar> */}
        <div className={classes.top}>
          <div className={classes.header}>
            <Typography variant="h3" gutterBottom>
              {getTranslate('User Permissions')}
            </Typography>
          </div>
          <Filters
            temporaryPermissions={temporaryPermissions}
            setfilteredPermissions={setfilteredPermissions}
          />
          <Typography variant="subtitle1" className={classes.sectionTitle}>
            {getTranslate('Permissions')}
          </Typography>
          <div className={classes.content}>
            {loadingForPermissions ? (
              <div className={classes.loadingContainer}>
                <CircularProgress size={36} />
              </div>
            ) : (
              filteredPermissions.map((permission) => (
                <PermissionBox
                  permission={permission}
                  initialPermissions={initialPermissions}
                  temporaryPermissions={temporaryPermissions}
                  setTemporayPermissions={setTemporaryPermissions}
                />
              ))
            )}
          </div>
        </div>
      </div>
      <div className={classes.footer}>
        <div></div>
        <div className={classes.btnContainer}>
          <Button
            variant="outlined"
            color="primary"
            className={classes.cancelBtn}
            onClick={() => {
              history.goBack()
            }}>
            <Typography className={classes.redText}>
              {getTranslate('Cancel')}
            </Typography>
          </Button>
          <Button
            variant="contained"
            color="primary"
            disabled={loadingForUpdatePermissions}
            onClick={() => {
              updateUserPErmissions({
                variables: {
                  input: {
                    userID: params.id,
                    permissionIDs: temporaryPermissions.flatMap((permission) =>
                      permission.subPermissions.flatMap((sub) =>
                        sub.actions
                          .filter(
                            (action) =>
                              action.permissionSource === 'UserBased' &&
                              action.selected &&
                              !action.disabled
                          )
                          .map((action) => action.permissionID)
                      )
                    )
                  }
                }
              })
            }}>
            <Typography className={classes.whiteText}>
              {getTranslate('Save Changes')}
              {loadingForUpdatePermissions && (
                <CircularProgress
                  className={classes.circularProgress}
                  size={16}
                />
              )}
            </Typography>
          </Button>
        </div>
      </div>
    </div>
  )
}

export default UserPermissions
